// noinspection JSUnresolvedReference

import React, {useEffect, useState} from "react";
import useAuthorityConfiguration from "../../../../../api/utilities/useAuthorityConfiguration.js";
import {ErpCalculationApi} from "../../../../../api/authority/generated/index";
import {useTranslation} from "react-i18next";
import DoughnutChart from "../../../../../mosaic/charts/DoughnutChart.jsx";
import {getContrastBackgroundColors, getContrastBackgroundHoverColors} from "../../../../../utils/graphColors.js";
import LoadingComponent from "../../../../../components/LoadingComponent.jsx";
import {useErrorTranslation} from "../../../../../api/utilities/translateErrorMessage.js";

export default function DailyCountryPerformance({title, day, project}) {

    let {t} = useTranslation();
    let {et} = useErrorTranslation();

    let [data, setData] = useState();

    let authorityConfiguration = useAuthorityConfiguration();

    useEffect(() => {
            new ErpCalculationApi(authorityConfiguration)
                .dailyCountryPerformance({
                    projectId: project.id,
                    dayInput: {
                        day: day.format('YYYY-MM-DD')
                    },
                })
                .then(setData)
                .catch(e => et(e).then(toast.error));
        },
        [day.format('YYYY-MM-DD'), project.id]
    );

    let [labels, setLabels] = useState([]);
    let [dataSource, setDataSource] = useState(null);

    useEffect(() => {

        let newLabels = [];
        let newDataSource = [];

        // noinspection JSUnresolvedReference
        for (let country of data?.topCountries ?? []) {
            if (country.countryName === 'default') {
                country.countryName = t('orders.unresolved-country');
            }

            newLabels.push(country.countryName);
            newDataSource.push(country.amount);
        }

        setLabels(newLabels);
        setDataSource(newDataSource);

    }, [data]);

    return (
        <LoadingComponent
            loading={data === null || dataSource === null}
            className={'col-span-12 sm:col-span-2 text-slate-600 dark:text-slate-400'}
        >
            <div
                className="comp__roundedBox inline-flex flex-col w-full rounded-sm text-sm bg-white dark:bg-slate-800 shadow-lg border border-slate-200 dark:border-slate-700">
                <div
                    className={'px-5 py-4 border-b border-slate-100 dark:border-slate-700 flex items-center'}>
                    <h2 className={'font-semibold text-slate-800 dark:text-slate-100'}>
                        {title}
                    </h2>
                </div>
                {dataSource !== null && data !== null &&
                    <DoughnutChart data={{
                        labels: labels,
                        datasets: [
                            {
                                data: dataSource,
                                backgroundColor: getContrastBackgroundColors(),
                                hoverBackgroundColor: getContrastBackgroundHoverColors(),
                                borderWidth: 0,
                            },
                        ],
                    }} height={200}/>
                }
            </div>
        </LoadingComponent>
    );
}
